export const tableHeaderData = [
  {
    header: 'Patient',
    width: '10rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'patient_name',
  },
  {
    header: 'MRN',
    width: '8rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'mrn',
  },
  {
    header: 'Program',
    width: '8rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'program_name',
  },
  {
    header: 'DOB',
    width: '5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'date_of_birth',
  },
  {
    header: 'Updated On',
    width: '8rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'modified_on',
  },
  {
    header: 'ID',
    width: '4rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'patient_id',
  },
  {
    header: 'Status',
    width: '5rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'is_inactive',
  },
  {
    header: 'Ref status',
    width: '5rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'referral_status',
  },
  {
    header: 'Referral updated on',
    width: '8rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'referral_last_modified_on',
  },
  {
    header: 'Clinic patient ID',
    width: '8rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'clinic_patient_id',
  },
  {
    header: 'SBP',
    width: '2rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'sbp',
  },
  {
    header: 'DBP',
    width: '2rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'dbp',
  },
  {
    header: 'Last BP recorded date',
    width: '8rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'last_recorded_date',
  },
  {
    header: 'Action',
    width: '3.2rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'action',
  },
]

export const tableHeaderAIDAData = [
  {
    header: 'Patient',
    width: '10rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'patient_name',
  },
  {
    header: 'MRN',
    width: '7rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'mrn',
  },
  {
    header: 'DOB',
    width: '4rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'date_of_birth',
  },
  {
    header: 'Updated On',
    width: '8rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'modified_on',
  },
  {
    header: 'Referral',
    width: '6rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'referral_pathway',
  },
  {
    header: 'Incoming diagnosis',
    width: '5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'confirmed_ca_diagnosis',
  },
  {
    header: 'Prior eval in CA Program',
    width: '6rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'prior_eval_in_ca_program',
  },
  {
    header: 'Stage',
    width: '5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'stage',
  },
  {
    header: 'Confirmed diagnosis',
    width: '5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'final_diagnosis',
  },
  // {
  //   header: 'Stage',
  //   width: '5rem',
  //   align: 'left',
  //   sort: 'none',
  //   sortColumn: 'stage',
  // },
  {
    header: 'Date evaluated',
    width: '6rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'date_evaluated',
  },
  {
    header: 'AL labs completed',
    width: '5rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'al_labs_completed',
  },
  {
    header: 'PYP ordered',
    width: '7rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'pyp_order_date',
  },
  {
    header: 'PYP completed',
    width: '7rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'pyp_result_arrival_date',
  },
  {
    header: 'MRI ordered',
    width: '7rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'mri_order_date',
  },
  {
    header: 'MRI completed',
    width: '7rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'mri_result_arrival_date',
  },
  {
    header: 'Test status',
    width: '4rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'test_status',
  },
  {
    header: 'Status',
    width: '3rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'is_inactive',
  },
  {
    header: 'ID',
    width: '3.5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'patient_id',
  },
  // {
  //   header: 'Clinical team',
  //   width: '5rem',
  //   align: 'center',
  //   sort: 'none',
  //   sortColumn: 'clinical_team',
  // },
  {
    header: 'Action',
    width: '3rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'action',
  },
]

export const tableHeadeClinicVisit = [
  {
    header: 'Patient',
    width: '10rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'patient_name',
  },
  {
    header: 'MRN',
    width: '7rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'mrn',
  },
  {
    header: 'DOB',
    width: '4rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'date_of_birth',
  },
  {
    header: 'Updated On',
    width: '8rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'modified_on',
  },
  {
    header: 'Status',
    width: '4.5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'clinic_visit_status',
  },
  {
    header: 'Cardiologist',
    width: '4.5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'amyloid_cardiologist',
  },
  {
    header: 'Visit date',
    width: '5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'clinic_visit_date',
  },
  // {
  //   header: 'Visit overdue',
  //   width: '5rem',
  //   align: 'center',
  //   sort: 'none',
  //   sortColumn: 'clinic_visit_overdue',
  // },
  {
    header: 'Referral',
    width: '6rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'referral_pathway',
  },
  {
    header: 'Incoming diagnosis',
    width: '5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'confirmed_ca_diagnosis',
  },
  {
    header: 'Prior eval in CA Program',
    width: '6rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'prior_eval_in_ca_program',
  },
  {
    header: 'Stage',
    width: '5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'stage',
  },
  {
    header: 'Confirmed diagnosis',
    width: '5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'final_diagnosis',
  },
  {
    header: 'AL labs completed',
    width: '5rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'al_labs_completed',
  },
  {
    header: 'PYP ordered',
    width: '7rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'pyp_order_date',
  },
  {
    header: 'PYP completed',
    width: '7rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'pyp_result_arrival_date',
  },
  {
    header: 'MRI ordered',
    width: '7rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'mri_order_date',
  },
  {
    header: 'MRI completed',
    width: '7rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'mri_result_arrival_date',
  },
  {
    header: 'Test status',
    width: '4rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'test_status',
  },
  {
    header: 'Status',
    width: '3rem',
    align: 'center',
    sort: 'none',
    sortColumn: 'is_inactive',
  },
  {
    header: 'ID',
    width: '3.5rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'patient_id',
  },
  // {
  //   header: 'Clinical team',
  //   width: '5rem',
  //   align: 'center',
  //   sort: 'none',
  //   sortColumn: 'clinical_team',
  // },
  {
    header: 'Action',
    width: '3rem',
    align: 'left',
    sort: 'none',
    sortColumn: 'action',
  },
]
